const appUrl = {
    // baseUrl: 'https://kblive.jappuat.com:8443/',
    baseUrl: 'https://qa-knowledgebase.appinsnap.com/',
   // baseUrl: 'https://kblive.jsbl.com/',
  

}
export default appUrl;
    